import { render, staticRenderFns } from "./IconQuantityEmpty.vue?vue&type=template&id=65aa222a&scoped=true"
import script from "./IconQuantityEmpty.vue?vue&type=script&lang=js"
export * from "./IconQuantityEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa222a",
  null
  
)

export default component.exports